import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-google-workspace-productivity',
  templateUrl: './google-workspace-productivity.component.html',
  styleUrl: './google-workspace-productivity.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class GoogleWorkspaceProductivityComponent implements OnInit {
  public pricePlans = [
    {
      title: 'Starter',
      cost: '1,650',
      discount: '3,300',
      save: '50%',
      costAnnually: '138',
      buttonClass: '',
    },
    {
      title: 'Standard',
      cost: '3,960',
      discount: '6,600',
      save: '40%',
      costAnnually: '330',
      buttonClass: 'btn-advance',
    },
    {
      title: 'Plus',
      cost: '10,200',
      costAnnually: '850',
      buttonClass: '',
    },
  ]
  public iconsWorkspace = [
    { name: 'Gmail' },
    { name: 'Chat' },
    { name: 'Calendar' },
    { name: 'Docs' },
    { name: 'Sheets' },
    { name: 'Slides' },
    { name: 'Keeps' },
    { name: 'Sites' },
    { name: 'Forms' },
    { name: 'AppSheet' },
    { name: 'Currents' },
    { name: 'CloudSearch' },
    { name: 'Drive' },
    { name: 'Meet' },
  ]

  public contentData: object[]
  public typePackage = 'Starter'
  constructor(public translate: TranslateService) {}
  ngOnInit() {
    this.showContentData()
  }
  showContentData() {
    const iconTrue = '<i class="fa fa-check"></i>'
    const iconFalse = '<i class="fas fa-minus"></i>'

    this.contentData = [
      {
        heading: 'Applications',
        content: [
          {
            name: 'Drive',
            detail: [
              {
                check: [
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.DRIVE.TABLE.1',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.DRIVE.TABLE.2',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.DRIVE.TABLE.3',
                ],
              },
              { check: [iconFalse, iconTrue, iconTrue] },
              { check: [iconFalse, iconTrue, iconTrue] },
            ],
          },
          {
            name: 'Meet',
            detail: [
              {
                check: [
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.MEET.TABLE.1',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.MEET.TABLE.2',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.APPLICATIONS.DETAIL.MEET.TABLE.3',
                ],
              },
              { check: [iconTrue, iconTrue, iconTrue] },
              { check: [iconFalse, iconTrue, iconTrue] },
            ],
          },
          { name: 'CloudSearch', detail: [{ check: [iconFalse, iconTrue, iconTrue] }] },
        ],
      },
      {
        heading: 'Future_ai',
        content: [
          {
            name: 'Gemini',
            detail: [
              {
                check: [
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.GEMINI.TABLE.1',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.GEMINI.TABLE.2',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.GEMINI.TABLE.3',
                ],
              },
            ],
          },
          {
            name: 'NotebookLM',
            detail: [
              {
                check: [
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.NOTEBOOKLM.TABLE.1',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.NOTEBOOKLM.TABLE.2',
                  'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.FUTURE_AI.DETAIL.NOTEBOOKLM.TABLE.3',
                ],
              },
            ],
          },
          { name: 'GoogleVids', detail: [{ check: [iconFalse, iconTrue, iconTrue] }] },
        ],
      },
      {
        heading: 'Security',
        content: [
          {
            name: 'Admin',
            detail: [
              { check: [iconTrue, iconTrue, iconTrue] },
              { check: [iconTrue, iconTrue, iconTrue] },
              { check: [iconFalse, iconFalse, iconTrue] },
              { check: [iconFalse, iconFalse, iconTrue] },
            ],
          },
          { name: 'Vault', detail: [{ check: [iconFalse, iconTrue, iconTrue] }] },
        ],
      },
    ]
  }

  getImageUrl(iconName: string) {
    const imageName = iconName.toLowerCase()
    return `https://flowaccountcdn.com/new_landing/image/google-workspace/productivity/${imageName}.png`
  }

  selectPackage(pack: string) {
    this.typePackage = pack
  }
}
